module.exports = __webpack_public_path__ + "static/media/6.708368ce.jpg";